import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation, clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    dealerId: null,
    billingAccount: null,
    billingAccounts: [],
    error: false,
};

const route = "dealers/views/.components/deleteBillingAccount/redux/slice";

export const deleteBillingAccount = createAsyncThunk("dealers/views/.components/deleteBillingAccount/redux/slice/deleteBillingAccount", async (payload, { rejectWithValue, dispatch }) => {
    const { id, newBillingAccountId } = payload
    try {
        let response = await clientMutation(`
            mutation deleteBillingAccount($id: Int!, $moveAssignedToBillingAccountId: Int) {
                result: deleteBillingAccount(id: $id, moveAssignedToBillingAccountId: $moveAssignedToBillingAccountId)
            }`,
            {
                id: id,
                moveAssignedToBillingAccountId: newBillingAccountId
            },
            endpoints.GRAPHQL_GENERAL
        )
        return { delete: response?.result }

    } catch (exc) {
        return rejectWithValue(exc);
    }
})

export const getBillingAccounts = createAsyncThunk("dealers/views/.components/deleteBillingAccount/redux/slice/getBillingAccounts", async (payload, { rejectWithValue, dispatch }) => {
    const { dealerId } = payload;
    try {
        let response = await clientQuery(`
            query searchBillingAccounts ($conditions: [ BillingAccountSearchInput ], $sort: [ BillingAccountSortInput ], $limit: Int, $offset: Int) {
                result: searchBillingAccounts (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                            id
                            name
                        }
                    total
                }
            }`,
            {
                conditions: [{fields: ["dealerId"], terms: [dealerId], exact: true, conditionOperator: "AND"}],
                sort: [{ field: "id", order: "ASC" }],
                limit: 1000,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL
        )
        return response?.result || { items: [], total: 0 }
    } catch (exc) {
        return rejectWithValue(exc);
    }
}
)

export const deleteBillingAccountRedux = createSlice({
    name: 'dealers/billingAccount/deleteBillingAccount',
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE }
        },
        openModalDeleteBillingAccount(state, action) {
            state.openModal = true
            state.billingAccount = action.payload.billingAccount
            state.dealerId = action.payload.dealerId;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(deleteBillingAccount.pending, (state, action) => {
            state.loading = true
        });
        builder.addCase(deleteBillingAccount.fulfilled, (state, action) => {
            state.result = action.payload
            state.loading = false;
        });
        builder.addCase(deleteBillingAccount.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
        });

        builder.addCase(getBillingAccounts.pending, (state, action) => {
            state.loading = true
        });
        builder.addCase(getBillingAccounts.fulfilled, (state, action) => {
            state.loading = false;
            state.billingAccounts = action.payload.items || [];
        });
        builder.addCase(getBillingAccounts.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
        });
    }
})

const { actions, reducer } = deleteBillingAccountRedux;

// Extract and export each action creator by name
export const {
    reset,
    openModalDeleteBillingAccount
} = actions;

export default reducer;
